import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import {
  Shield, LayoutDashboard, Trophy, Users, CreditCard,
  MessageSquare, Activity, LogOut, Sparkles, Archive,
} from "lucide-react";

const NAV = [
  { to: "/superadmin", label: "Panoramica", icon: LayoutDashboard, end: true, tid: "sa-nav-overview" },
  { to: "/superadmin/leghe", label: "Leghe", icon: Trophy, tid: "sa-nav-leagues" },
  { to: "/superadmin/utenti", label: "Utenti", icon: Users, tid: "sa-nav-users" },
  { to: "/superadmin/pagamenti", label: "Pagamenti", icon: CreditCard, tid: "sa-nav-payments" },
  { to: "/superadmin/messaggi", label: "Messaggi", icon: MessageSquare, tid: "sa-nav-messages" },
  { to: "/superadmin/sponsor", label: "Sponsor", icon: Sparkles, tid: "sa-nav-sponsors" },
  { to: "/superadmin/archivio-quotazioni", label: "Archivio Quotazioni", icon: Archive, tid: "sa-nav-archive" },
  { to: "/superadmin/health", label: "Salute Sistema", icon: Activity, tid: "sa-nav-health" },
];

export default function SuperAdminLayout() {
  const [me, setMe] = useState(null);
  const [checked, setChecked] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/superadmin/me");
        setMe(data);
      } catch {
        nav("/superadmin/login", { replace: true });
      } finally {
        setChecked(true);
      }
    })();
  }, [nav]);

  async function logout() {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    nav("/superadmin/login", { replace: true });
  }

  if (!checked) {
    return (
      <div className="min-h-screen bg-[#0b1120] text-slate-100 flex items-center justify-center">
        <div className="font-mono tracking-[0.4em] text-slate-500 uppercase text-sm">Caricamento…</div>
      </div>
    );
  }
  if (!me) return null;

  return (
    <div className="min-h-screen bg-[#0b1120] text-slate-100 flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 bg-slate-950/60 backdrop-blur border-r border-slate-800 flex flex-col">
        <div className="px-6 py-6 border-b border-slate-800">
          <div className="flex items-center gap-3">
            <img src="/brand/logo-128.png" alt="MyFantabusiness" className="w-11 h-11 object-contain drop-shadow-[0_4px_12px_rgba(244,63,94,0.35)]"/>
            <div>
              <div className="text-[10px] tracking-[0.3em] text-rose-400 uppercase font-bold">MyFantaBusiness</div>
              <div className="font-black uppercase tracking-wider text-sm">Super Admin</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.tid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-rose-500/15 text-rose-300 border border-rose-500/30"
                    : "text-slate-400 hover:bg-slate-800/60 hover:text-slate-100 border border-transparent"
                }`
              }
            >
              <item.icon size={16}/> {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 py-4 border-t border-slate-800 space-y-3">
          <div className="px-3 text-xs">
            <div className="text-slate-400 truncate">{me.email}</div>
            <div className="text-rose-400 text-[10px] uppercase tracking-widest font-bold">Super Admin</div>
          </div>
          <button
            onClick={logout}
            data-testid="sa-logout-btn"
            className="w-full inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm border border-slate-700 hover:border-rose-500 hover:bg-rose-500/10 text-slate-300 transition-colors"
          >
            <LogOut size={14}/> Esci
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-y-auto">
        <Outlet/>
      </main>
    </div>
  );
}
